import {Component, EventEmitter, Input, Output, ViewChild} from "@angular/core";
import {CommonMessagesService} from "src/app/services/common-messages.service";

@Component({
  selector: 'app-upload-csv',
  templateUrl: './upload-csv.component.html',
})
export class UploadCsvComponent {

  @Input() fileExtensions: string[] = [];
  @Input() disabled: boolean = false;
  @Output() onFileDropped: EventEmitter<File[]> = new EventEmitter<File[]>();

  @ViewChild('fileInput') attachments: any;


  constructor(private readonly commonMessageService: CommonMessagesService) {
  }

  uploadFile(fileList: FileList): void {
    const files: File[] = [];
    for (const file of fileList) {
      if (this.checkExtension(file.name)) {
        files.push(file);
      }
    }
    if (files.length > 0) this.onFileDropped.emit(files);
    this.attachments.nativeElement.value = '';
  }

  checkExtension(fileName: string): boolean {
    let extension = fileName.split('.').pop();
    if (this.fileExtensions.includes(extension)) {
      return true;
    } else {
      this.commonMessageService.showUnexpectedPersistingError('create');
      return false;
    }
  }

}
